import { ACTION } from './action-types';
import * as actions from './action-types';
import { ActionMap } from 'app/area/my-downloads/types';
import { ExportsViewState } from 'app/area/my-downloads/exports/exports-view/types-store';

export const INITIAL_EXPORTS_VIEW_STATE: ExportsViewState = {
  exportsView: {
    download: undefined,
    fetching: false,
    exportStatus: undefined
  }
};

export const reducers: ActionMap = {

  [ACTION.REQUEST_EXPORT_STATUS]: (state: ExportsViewState, action: actions.RequestExportStatus): ExportsViewState => {

    return {
      ...state,
      exportsView: {
        ...state.exportsView,
        fetching: true
      }
    };
  },

  [ACTION.RECEIVE_EXPORT_STATUS]: (state: ExportsViewState, action: actions.ReceiveExportStatus): ExportsViewState => {

    return {
      ...state,
      exportsView: {
        ...state.exportsView,
        exportStatus: action.exportStatus,
        fetching: false
      }
    };
  },

  [ACTION.FAIL_EXPORT_STATUS]: (state: ExportsViewState, action: actions.FailExportStatus): ExportsViewState => {

    return {
      ...state,
      exportsView: {
        ...state.exportsView,
        fetching: false
      }
    };
  },

  [ACTION.REQUEST_DOWNLOAD_CASE_EXPORT_PACKAGE]: (state: ExportsViewState,
    action: actions.RequestDownloadCaseExportPackage): ExportsViewState => {
    return {
      ...state,
      exportsView: {
        ...state.exportsView,
        download: {
          exportId: action.exportId,
          fetching: true
        }
      }
    };
  },

  [ACTION.RECEIVE_DOWNLOAD_CASE_EXPORT_PACKAGE]: (state: ExportsViewState,
    action: actions.ReceiveDownloadCaseExportPackage): ExportsViewState => {
    return {
      ...state,
      exportsView: {
        ...state.exportsView,
        download: undefined
      }
    };
  },

  [ACTION.FAIL_DOWNLOAD_CASE_EXPORT_PACKAGE]: (state: ExportsViewState,
    action: actions.FailDownloadCaseExportPackage): ExportsViewState => {
    return {
      ...state,
      exportsView: {
        ...state.exportsView,
        download: undefined
      }
    };
  }
};
